import {ArcElement, Chart as ChartJS, Legend, Tooltip} from "chart.js";
import {css} from "@emotion/css";
import {Doughnut} from "react-chartjs-2";
import React from "react";

export const RaikoDoughnutChart = ({labels, datasets}) => {

    ChartJS.register(ArcElement, Tooltip, Legend);

    const data = {
        labels: labels,
        datasets: datasets
    };

    const options = {
        plugins: {
            legend: {
                labels: {
                    font: {
                        size: "14",
                        family: "iranYekanRegular, sans-serif"
                    }
                }
            },
        }
    }

    return (
        <section className={css`width: 100%;
          display: grid;
          place-items: center`}>
            <div className={css`width: 500px;
              font-family: iranYekanRegular, sans-serif;
              height: 500px;`}>
                <Doughnut options={options} data={data}/>
            </div>
        </section>

    )
}

export function prepareDoughnutChartDatasetItem(label, data, background, borderColor=[], borderWidth = 1) {
    return {
        label: label,
        data: data,
        backgroundColor: background,
        borderColor: borderColor ? borderColor : background,
        borderWidth: borderWidth,
    }
}

